import React, { useState } from 'react';

import WebcamView from '../../MediaDevices/WebcamView';
import DeviceSelector from '../../MediaDevices/DeviceSelector';


const ResolutionSelector = ({ label, prefix, initial, kind, ...props }) => {
    const [value, setValue] = useState(initial || 'auto');

    return (
        <div className={"device-selector device-selector--iconed" + (prefix ? " device-selector--prefixed" : "")}>
            <label className="device-selector__label">{ label }</label>
            {(typeof prefix === "string" && prefix) && <i className={"device-selector__prefix " + prefix} />}
            <div className="device-selector__container">
                <select className="device-selector__input" onChange={(e) => { 
                        let value = e.target.value;
                        setValue(value); 
                        window.sdk.videoconf().mediaDevices().setVideoResolution(kind, value) 
                    }} value={ value }>
                    <option value="auto">Automatique</option>
                    <option value="720p">HD 720p</option>
                    <option value="360p">360p</option>
                    <option value="180p">180p</option>
                </select>
            </div>
        </div>
    );
};


export default class Video extends React.Component {
    state = {
        show:false,
        videoinput: []
    }

    async loadDevices() {
        let { devices } = await window.sdk.videoconf().getDevices();

        this.setState({
            show: true,
            videoinput: devices['videoinput']
        });
    }

    async componentDidMount() {

        window.sdk.event().on('deviceChange', () => {
            this.loadDevices(); 
        })

        this.loadDevices();
    }
	
	render() {
        if(!this.state.show)
        return null;
		return (
			<div className="settings-video">										

				<div className="test-device__row">
					<div className="test-device__col">
						<WebcamView noscale={true} noaudiometer={true} />
					</div>
					<div className="test-device__col">
                        <div className="settings__block">
                            <h3 className={'settings__subtitle'}>Réglages vidéo</h3>

                            <div className="device-selector-wrapper">
                                <DeviceSelector kind="videoinput" label="Caméra" devices={ this.state.videoinput } prefix="icon-cam" />

                                <ResolutionSelector label="Résolution vidéo à la réception" kind="recv" initial={ window.sdk.videoconf().mediaDevices().getVideoResolution('recv') } prefix="icon-quality-down" />

                                <ResolutionSelector label="Résolution vidéo à l'envoi" kind="send" initial={ window.sdk.videoconf().mediaDevices().getVideoResolution('send') } prefix="icon-quality-up" />
                            </div>
                        </div>
					</div>
				</div>
            </div>
		);
	}
}
